import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import './styles/base.css';
import App from './App.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// registerType: 'autoUpdate' — new SW versions take over silently on next load,
// no update-available prompt UI (out of scope for Phase 0). Precaches the app
// shell only; see src/pwa/manifest.ts and vite.config.ts for the no-API-caching rule.
registerSW({ immediate: true });
